import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import headerBg from "./assets/picOne.png"; 
import HPLC from "./assets/DSC_0058.JPG";
import engineering from "./assets/DSC_0044.JPG";
import gcl1 from "./assets/20251212_094815.jpeg";
import gcl2 from "./assets/20251212_094832.jpeg";
import ichromatography from "./assets/20251212_095031.jpeg"; 
import adap from "./assets/20251212_100510.jpeg"; 
import adapp from "./assets/20251212_100514.jpeg";
import pesticides from "./assets/DSC_0057.JPG";
import Radiochemistry from "./assets/20251212_100132.jpeg";

const TestingLaboratories = () => {
  const location = useLocation();

  const laboratories = [
    {
      name: "General Chemistry Laboratory",
      description: "This laboratory is used for testing of the chemical composition of various products.",
      instruments: [
        { name: "Inductively Coupled Plasma - ICP-OES", description: "", image: gcl1 },
        { name: "ICP-MS Mass Spectrometer", description: "", image: gcl2 },
      
      
      ],
    },
    {
      name: "Food Chemistry Laboratory",
      description: "For testing of the chemical composition of food products.",
      instruments: [
        { name: "Ion Chromatography", description: "High performance chromatography for water chemistry analysis measuring major anions and cations in low concentrations.", image: ichromatography },
        { name: "High Performance Liquid Chromatograph (HPLC)", description: "Used for separation, identification, and quantification of compounds. Especially used for aflatoxin analysis in agricultural products.", image: HPLC },
      
      ],
    },
    {
      name: "Petrochemicals Laboratory",
      description: "For testing the quality parameters of petroleum products.",
      instruments: [
        { name: "Atmospheric Distillation Analyser", description: "Analyzes compositions and purity of petroleum products including petrol, diesel, paraffin, and aircraft fuel with precision and accuracy.", image: adap },
        { name: "Atmospheric Distillation Analyser", description: "Analyzes compositions and purity of petroleum products including petrol, diesel, paraffin, and aircraft fuel with precision and accuracy.", image: adapp },
     
      ],
    },
    {
      name: "Pesticides Residues and Formulation Laboratory",
      description: "For testing residual pesticides in food and agricultural produce, and pesticide formulations for active ingredients.",
      instruments: [
        { name: "Shimadzu LCMS-8060", description: "Pesticide Residues Testing Equipment", image: pesticides },
      ],
    },
    {
      name: "Microbiology Laboratory",
      description: "For checking the microbiological quality of food, water, pharmaceuticals and other products.",
      instruments: [],
    },
    {
      name: "Radiochemistry Laboratory",
      description: "For carrying out tests for radioactive material in products such as tea, tobacco, and other samples.",
      instruments: [
        { name: "Gamma-Ray Spectrometer", description: "Used for qualitative and quantitative analysis of radionuclides in environmental samples.", image: Radiochemistry },
      ],
    },
    {
      name: "Engineering and Materials Laboratories",
      description: "For testing of textile and leather products, packaging, and building materials.",
      instruments: [
        { name: "UTM – Universal Testing Machine", description: "For tensile and compression tests of materials.", image: engineering  },
      ],
    },
  ];

  // Scroll to section if state is passed
  useEffect(() => {
    if (location.state?.scrollTo) {
      const labName = location.state.scrollTo.replace(/\s+/g, '-');
      const element = document.getElementById(labName);
      if (element) {
        const yOffset = -80;
        const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({ top: y, behavior: "smooth" });
      }
    }
  }, [location.state]);

  return (
    <div className="about-us">
      {/* Header */}
      <section className="about-header">
        <div className="overlay">
          <h1 className="page-title">Testing Laboratories</h1>
          <p className="subtitle">
            Malawi Bureau of Standards (MBS) operates accredited testing laboratories providing reliable analysis for various products and materials.
          </p>
        </div>
      </section>

      {/* Laboratories */}
      <section className="labs-section">
        {laboratories.map((lab, idx) => (
          <div key={idx} id={lab.name.replace(/\s+/g, '-')} className="lab-card">
            <h2>{lab.name}</h2>
            <p>{lab.description}</p>

            {lab.instruments.length > 0 && (
              <div className="instruments-section">
                {lab.instruments.map((inst, i) => (
                  <div key={i} className="instrument-card">
                    <img src={inst.image} alt={inst.name} />
                    <h3>{inst.name}</h3>
                    <p>{inst.description}</p>
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </section>

      {/* CSS */}
      <style>{`
        .about-us { font-family: Arial, sans-serif; color: #333; }

        .about-header {
          background-image: url(${headerBg});
          background-size: cover;
          background-position: center;
          height: 45vh;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .overlay {
          background: rgba(0,0,0,0.55);
          padding: 40px;
          text-align: center;
          color: white;
          width: 90%;
          max-width: 1200px;
          border-radius: 12px;
        }

        .page-title { font-size: 3rem; font-weight: bold; margin-bottom: 10px; }
        .subtitle { font-size: 1.1rem; line-height: 1.6; }

        .labs-section { padding: 50px 20px; max-width: 1600px; margin: auto; }
        .lab-card { background: #f9f9f9; border-radius: 12px; padding: 40px 50px; margin-bottom: 50px; box-shadow: 0 6px 25px rgba(0,0,0,0.12); cursor: pointer; transition: all 0.3s ease; }
        .lab-card:hover { transform: translateY(-5px); box-shadow: 0 10px 30px rgba(0,0,0,0.15); }

        .lab-card h2 { color: #ff6600; margin-bottom: 20px; font-size: 1.9rem; }
        .lab-card p { margin-bottom: 18px; line-height: 1.7; font-size: 1.05rem; }

        .instruments-section { display: flex; flex-wrap: wrap; gap: 25px; margin-top: 20px; }
        .instrument-card { background: white; border: 1px solid #ff6600; border-radius: 12px; padding: 25px; flex: 1 1 350px; text-align: center; transition: 0.3s; }
        .instrument-card img { max-width: 100%; height: 200px; border-radius: 8px; margin-bottom: 12px; }
        .instrument-card h3 { margin-bottom: 12px; color: #333; font-size: 1.1rem; }
        .instrument-card p { font-size: 1rem; line-height: 1.5; }
        .instrument-card:hover { transform: translateY(-5px); box-shadow: 0 10px 30px rgba(0,0,0,0.15); }

        @media screen and (max-width: 768px) {
          .overlay { padding: 25px; }
          .page-title { font-size: 2rem; }
          .lab-card { padding: 25px; }
          .instrument-card { flex: 1 1 100%; }
        }
      `}</style>
    </div>
  );
};

export default TestingLaboratories;
